class ResparkleModalDialog extends HTMLElement {
  constructor() {
    super()
    this.querySelector(".resparkle-modal-close-btn").addEventListener(
      "click",
      () => {
        this.hideModal()
      }
    )
    this.addEventListener("click", e => {
      if (e.target.classList.contains("resparkle-modal-dialog-wrapper")) {
        this.hideModal()
      }
    })
    this.addEventListener("keyup", event => {
      if (event.code.toUpperCase() === "ESCAPE") this.hideModal()
    })
  }

  showModal(opener) {
    this.openedBy = opener
    document.body.classList.add("overflow-hidden")
    this.setAttribute("open", "")
    trapFocus(this, this.querySelector('[role="dialog"]'))
    window.pauseAllMedia()
  }

  hideModal() {
    document.body.classList.remove("overflow-hidden")
    this.removeAttribute("open", "")
    removeTrapFocus(this.openedBy)
  }
}

customElements.define("resparkle-modal-dialog", ResparkleModalDialog)

class ResparkleModalOpener extends HTMLElement {
  constructor() {
    super()

    this.addEventListener("click", () => {
      const modal = document.querySelector(
        `[data-modal-dialog = ${this.getAttribute("data-modal")}]`
      )
      if (modal) modal.showModal(this)
    })
    this.addEventListener("keydown", e => {
      if (e.key == "Enter") {
        const modal = document.querySelector(
          `[data-modal-dialog = ${this.getAttribute("data-modal")}]`
        )
        if (modal) modal.showModal(this)
      }
    })
  }
}

customElements.define("resparkle-modal-opener", ResparkleModalOpener)

const resparkleModal = new Swiper(".rmo-container", {
  // Optional parameters
  mousewheel: {
    forceToAxis: true,
  },
  freeMode: {
    enabled: true,
  },

  breakpoints: {
    // when window width is >= 320px
    990: {
      slidesPerView: 3.2,
      spaceBetween: 20,
      cssMode: true,
    },
    // when window width is >= 480px
    750: {
      slidesPerView: 2.5,
      spaceBetween: 20,
      cssMode: true,
    },
    // when window width is >= 640px
    0: {
      slidesPerView: 1.8,
      spaceBetween: 10,
      cssMode: true,
    },
  },
})
